export function user(state) {
  return state.user
}

export function tempUser2(state) {
  return state.tempUser2
}

export function appleUser(state) {
  return state.appleUser
}

export function authType(state) {
  return state.authType
}

export function facebookUser(state) {
  return state.facebookUser
}

export function googleUser(state) {
  return state.googleUser
}

export function tempUser(state) {
  return state.tempUser
}

export function socialRegistering(state) {
  return state.socialRegistering
}

export function userId(state) {
  return state?.user?.id
}

export function userIdentifier(state) {
  return state?.user?.identifier
}

export function userName(state) {
  return state?.user?.userName
}

export function profileImageId(state) {
  return state?.user?.profile?.imageUuid
}

export function profileImage(state) {
  console.log('state.user', state.user)
  return state?.user?.profile?.image
}

export function userCredits(state) {
  try {
    return state?.user?.account?.credits
  } catch (e) {
    return 0
  }
}

export function token(state) {
  return state?.token
}

export function credits(state) {
  return state?.user?.account?.credits
}

export function fullname(state) {
  return state?.user && state.user?.firstName ? state.user?.firstName + ' ' + state.user?.lastName : ''
}

export function freeCallUser(state) {
  return state.user?.freeCallUser
}

export function userPhoneNumber(state) {
  return state.user?.phoneNumber
}

export function userEmail(state) {
  return state.user?.email
}

export function userGender(state) {
  return state.user?.profile?.gender
}

export function userCountry(state) {
  return state.user?.profile?.country
}

export function userOnlineStatus(state) {
  return state.user?.profile?.onlineStatus
}

export function userCanChangeOnlineStatus(state) {
  return state.user?.canChangeOnlineStatus
}

export function userCanStartVideoCall(state) {
  return state.user?.canStartVideoCall
}

export function userCanReceiveVideoCall(state) {
  return state.user?.canReceiveVideoCall
}

export function userZoomStatus(state) {
  return state.user?.profile?.zoomStatus
}

export function userSource(state) {
  return state.user?.userSource
}

export function dupDevice(state) {
  return state.user?.dupDevice
}
